import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { updateTranslationEvent } from './updateEvent';
import ChainedBackend from 'i18next-chained-backend';
import { i18nextPlugin } from 'translation-check';
export const getLanguage = (brand) => {
    return brand === 'finn' ? 'no' : 'se';
};
export const initI18N = async (brand = 'blocket', basePath = 'https://dev.finn.no/feedback/api') => {
    if (!i18n.isInitialized) {
        const lng = getLanguage(brand);
        await i18n
            .use(i18nextPlugin)
            .use(ChainedBackend)
            .init({
            lng,
            nsSeparator: ':',
            supportedLngs: ['se', 'no'],
            preload: ['se', 'no'],
            backend: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                backends: [HttpBackend],
                backendOptions: [
                    {
                        loadPath: `${basePath}/translation/{{lng}}`,
                    },
                ],
            },
        }, () => {
            window.dispatchEvent(updateTranslationEvent);
        });
    }
};
export default i18n;
//# sourceMappingURL=i18next.js.map